const serviceRoot = 'api/noPermitRequired/';

export const NprEndpoints = {
  addNpr: () => `${serviceRoot}addNpr`,
  updateNpr: () => `${serviceRoot}updateNpr`,
  getNpr: () => `${serviceRoot}getNpr`,
};
